import { render, staticRenderFns } from "./ProjectsManagement.vue?vue&type=template&id=f307c2a0&scoped=true&"
import script from "./projects-management.ts?vue&type=script&lang=ts&"
export * from "./projects-management.ts?vue&type=script&lang=ts&"
import style0 from "./ProjectsManagement.vue?vue&type=style&index=0&id=f307c2a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f307c2a0",
  null
  
)

export default component.exports